import React, { useState } from "react";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Pagination from "@mui/material/Pagination";
import { CustomPaginationCommon } from "modules/Users/components";
import LearningCard from "../MyLearningData/LearningCard";
import { useNavigate } from "react-router-dom";
import { timeStamp } from "node:console";
import { Purchase } from "types";
import { title } from "node:process";

type LearningLogDataProps = {
  learningLogData: any[];
  loading: boolean;

};

const LearningLogData: React.FC<LearningLogDataProps> = ({
  learningLogData,
  loading,

}) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);


  const navigate = useNavigate();

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  // const getPaginatedData = () => {
  //   const startIndex = (page) * rowsPerPage;
  //   return learningLogData.slice(startIndex, startIndex + rowsPerPage);
  // };
  const getPaginatedData = () => {
    const sortedData = [...learningLogData].sort(
      (a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)
    );
    const startIndex = page * rowsPerPage;
    return sortedData.slice(startIndex, startIndex + rowsPerPage);
  };


  const handleStartClick = (item: any) => {
  };

  const handleContinueClick = (item: any) => {
  };

  const handleDownloadClick = (item: any) => {
  };
  const handleNavigateMyLearningBack = () => {
    navigate(-1);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage); // ✅ Zero-based pagination
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // ✅ Reset to first page when rows per page changes
  };

  return (
    <Grid position="relative" justifyContent="center">
      <Grid
        item
        xs={12}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={3}
        px={{ xs: 2, md: "85px" }}
      >
        <Box
          pt={5}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            onClick={handleNavigateMyLearningBack}
            fontWeight={500}
            fontFamily={"Atten Round New"}
            fontSize="28px"
            color="#233F91"
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer" }}
          >
            <KeyboardArrowLeftIcon />
            Learning Log
          </Box>
        </Box>
        <Grid item xs={10}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "35px",
            }}
          >
            <Box sx={styleSheet.tableHeader}>
              <Typography sx={styleSheet.contentName}>Content Name</Typography>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                gap={{ xs: "32px", md: "0px" }}
              >
                <Typography sx={styleSheet.dateAccess} className="columnRow">
                  Date Accessed
                </Typography>
                <Typography sx={styleSheet.timeAccess} className="columnRow">
                  Time Accessed
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: { xs: "10px", md: "24px" },
                display: "flex",
                flexDirection: "column",
                gap: "28px",
                border: "1px solid #E5E5E5",
              }}
            >

              {loading ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minHeight="70vh"
                // width="100vw"
                >
                  <CircularProgress sx={{ color: "#233F91" }} />
                </Box>
              ) : learningLogData?.length === 0 ? (
                <Box
                  flex={1}
                  display="flex"
                  alignItems={"center"}
                  justifyContent={"center"}
                // width="100vw"
                >
                  <Typography
                    display="flex"
                    alignItems="center"
                    fontSize={22}
                    color="#797979"
                    fontWeight={400}
                  >
                    Your cart is empty
                  </Typography>
                </Box>
              ) : (
                getPaginatedData().map((learning: any) => (
                  <table
                    key={learning.id}
                    style={{
                      borderBottom: "1px solid #E5E5E5",
                      paddingBottom: "20px",
                    }}
                    className="rowHeader"
                  >
                    <Typography
                      sx={styleSheet.contentNameRow}
                      className="ellipsis"
                    >
                      <Typography>{learning.contentTitle}</Typography>
                    </Typography>
                    <Typography
                      display={"flex"}
                      justifyContent={"space-between"}
                      gap={{ xs: "32px", md: "0px" }}
                    >
                      <Typography sx={styleSheet.dateRow} className="rowDatep">
                        {new Date(
                          learning.createdAt.seconds * 1000
                        ).toLocaleDateString()}
                      </Typography>
                      <Typography
                        sx={styleSheet.timeRow}
                        className="rowContentp"
                      >
                        {new Date(
                          learning.createdAt.seconds * 1000
                        ).toLocaleTimeString()}
                      </Typography>
                    </Typography>
                  </table>
                ))
              )}

              <Box
                display={"flex"}
                justifyContent={"center"}
                alignContent={"center"}
                m={5}
              >

                <CustomPaginationCommon
                  count={learningLogData.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LearningLogData;

const styleSheet = {
  tableHeader: {
    backgroundColor: "#eff4fa",
    borderRadius: "15px",
    padding: { xs: "10px", md: "24px" },
    display: "flex",
    color: "#233f91",
    justifyContent: "space-between",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  contentName: {
    width: { xs: "68%", md: "100%" },
    color: { xs: "#313131", md: "#233F91" },
    fontWeight: { xs: 700, md: 700 },
  },
  dateAccess: {
    width: { xs: "100%", md: "300px" },
    color: { xs: "#313131", md: "#233F91" },
    fontWeight: { xs: 700, md: 700 },
  },
  timeAccess: {
    width: { xs: "100%", md: "150px" },
    color: { xs: "#313131", md: "#233F91" },
    fontWeight: { xs: 700, md: 700 },
  },
  contentNameRow: {
    fontSize: { xs: "17px", md: "18px" },
    fontWeight: 400,
    fontFamily: "Atten Round New",
    width: { xs: "55%", md: "100%" },
  },
  dateRow: {
    width: { xs: "50%", md: "320px" },
    color: "#313131",
    fontFamily: "Atten Round New",
  },
  timeRow: {
    width: { xs: "50%", md: "130px" },
    fontFamily: "Atten Round New",
  },
};
